import { Injectable } from '@angular/core';
import {HttpManagerService}  from '../httpmanager.service';
import {ApiConstant} from '../api.constant';

@Injectable()
export class TraineeService {

  private mainurl : String;
  constructor(private httpmanagerService: HttpManagerService,private apiservice: ApiConstant) { 
    this.mainurl = apiservice.Server;
  }

  allnewproject(): Promise<any> {
    return this.httpmanagerService.HttpGet('trainee', '').then(data => {
        if (data) {
            return data.data;
        }
    })
}

dHiring(id): Promise<any>{
  return this.httpmanagerService.HttpDelete('trainee',id).then(data =>{
      return data;
  })
}

downloadFile(name)
{
  
    this.mainurl=this.apiservice.ServerUrl;
    window.location.href=this.mainurl+'uploads/training_letter/'+name;
}

}



// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/api/trainee/trainee.service.ts